import React, { useRef, useEffect, useState, useContext } from "react";

// Componentes PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";


import { obtenerProductosAct } from "../../../../../../API/Global/Productos/ProductosRequests";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext"; 

const ProductosOverlayPanel = ({ MateriaPrima, Requisa = false,close, rowData, onChange, code = null, IdCategoria = null }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [productos, setProductos] = useState([]);

  const obtenerProductosActivos = async () => {
    setLoading(true);
  
    const tempo = await obtenerProductosAct();
    let data;
    if (Requisa === true) {
      data = tempo.filter((i) => [34, 35].includes(Number(i.IdType)));
    } else if (MateriaPrima === true) {
      data = tempo.filter((i) => Number(i.IdType) === 34);
    } else if (MateriaPrima === false) {
      data = tempo.filter((i) => Number(i.IdType) === 35);
    } else {
      data = tempo;
    }
  
    // console.log("Productos después del filtro:", data);
  
    setProductos(data);
    setLoading(false);
  };

  const colums = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdProduct",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "small",
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "Xlarge",
      flex: 1,
      Sumary: "count",
    },
    {
      // Quantity
      field: "TotalInventario",
      header: "Invetario",
      headerEn: "Invetary",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreCategoria",
      className: 'small'
    },
    {
      header: "Sub-Categoría",
      headerEn: "Sub-Category",
      field: "NombreSubcategoria",
      className: "medium",
    },
    {
      header: "Unidad",
      headerEn: "Unit",
      field: "UnitSimbol",
      className: "Xsmall",
    },
    // {
    //   header: "Costo",
    //   headerEn: "Cost",
    //   field: "Costo",
    //   Format: "Currency",
    //   className: "Xsmall",
    // },
  ];

  const table = {
    Columns: colums,
    Data: productos,
    loading: loading,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    obtenerProductosActivos();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={code === 1 ? rowData.CodigoProducto : rowData.NombreProducto}
          disabled
          placeholder="Producto"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1000, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default ProductosOverlayPanel;
